import React, { memo } from 'react';
import PropTypes from 'prop-types';
import EntityChip from './EntityChip';

const propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    entity: PropTypes.string,
    id: PropTypes.any,
    idIconField: PropTypes.any,
    isDismissible: PropTypes.bool,
    name: PropTypes.string,
    onClick: PropTypes.func,
    onClickDismissible: PropTypes.func,
    remotePopover: PropTypes.bool,
    text: PropTypes.string,
};

const EntityChipRow = memo(
    ({
        entity,
        id,
        name,
        onClick,
        onMouseEnter,
        onMouseLeave,
        className,
        isDismissible,
        onClickDismissible,
        idIconField,
        labelColor,
        color,
        text,
        remotePopover,
    }) => {
        const labelClasses = ['fm-entity-chip-row__text'];
        if (color || labelColor) {
            switch (color || labelColor) {
                case 'error':
                    labelClasses.push('fm-entity-chip-row__text--error');
                    break;
                case 'warning':
                    labelClasses.push('fm-entity-chip-row__text--warning');
                    break;
                case 'success':
                default:
                    labelClasses.push('fm-entity-chip-row__text--success');
                    break;
            }
        }
        return (
            <div className="fm-entity-chip-row">
                <div className="fm-entity-chip-row__chip">
                    <EntityChip
                        entity={entity}
                        id={id}
                        name={name}
                        onClick={onClick}
                        onMouseEnter={onMouseEnter}
                        onMouseLeave={onMouseLeave}
                        className={className}
                        isDismissible={isDismissible}
                        onClickDismissible={onClickDismissible}
                        idIconField={idIconField}
                        color={color}
                        remotePopover={remotePopover}
                    />
                </div>
                <div className={labelClasses.join(' ')}>{text}</div>
            </div>
        );
    },
);

EntityChipRow.propTypes = propTypes;

export default EntityChipRow;
